import { useTranslation } from 'react-i18next'

const BookingLegend = () => {
  const { t } = useTranslation('bookings')

  return (
    <div className="booking-legend ph-row mt-16">
      <span className="legend-item ph-row">
        <span className="legend-dot selected" />
        {t('booking.booking-courts.selected')}
      </span>
      <span className="legend-item ph-row">
        <span className="legend-dot booked" />
        {t('booking.booking-courts.booked')}
      </span>
      <span className="legend-item ph-row">
        <span className="legend-dot held" />
        {t('booking.booking-courts.held')}
      </span>
      <span className="legend-item ph-row">
        <span className="legend-dot blocked" />
        {t('booking.booking-courts.blocked')}
      </span>
      <span className="legend-item ph-row">
        <span className="legend-dot available" />
        {t('booking.booking-courts.available')}
      </span>
    </div>
  )
}

export default BookingLegend
